import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, ClientCreationDTO, ClientDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-admin-client-edit',
  templateUrl: './admin-client-edit.component.html',
  styleUrls: ['./admin-client-edit.component.scss'],
  standalone: false,
})
export class AdminClientEditComponent implements OnInit {
  client: ClientDTO;
  clientId: number;
  form: UntypedFormGroup;
  loading: boolean;
  point: any;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorhandler: ErrorService,
    private destroyRef: DestroyRef
  ) {
    this.loading = true;
    this.client = undefined;
    this.clientId = undefined;
    this.form = new UntypedFormGroup({
      Name: new UntypedFormControl('', [Validators.required]),
      EMail: new UntypedFormControl(''),
      Identifier: new UntypedFormControl(''),
    });
  }

  registerFormChangesListener() {
    this.Name.valueChanges.subscribe(value => {
      this.client.name = value;
    });
    this.Identifier.valueChanges.subscribe(value => {
      this.client.primaryCompany.identifier = value;
    });
    this.EMail.valueChanges.subscribe(value => {
      this.client.primaryCompany.email = value;
    });
  }

  get Name() {
    return this.form.get('Name');
  }

  get EMail() {
    return this.form.get('EMail');
  }

  get Identifier() {
    return this.form.get('Identifier');
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe({
      next: params => {
        this.clientId = params.clientID;
        this.refreshFromServer();
      },
    });
    this.registerFormChangesListener();
  }

  ok() {
    this.loading = true;
    if (this.clientId) {
      // EDIT
      this.api
        ._admin_Client_edit(this.client)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: () => {
            this.util.returnToNavigation(this.util.RoutingID.adminClientManagement);
          },
          error: error => {
            this.errorhandler.errorHandler(error);
          },
        });
    } else {
      // CREATE
      this.api
        ._admin_Client_create(this.client as ClientCreationDTO)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: () => {
            this.util.returnToNavigation(this.util.RoutingID.adminClientManagement);
          },
          error: error => {
            this.errorhandler.errorHandler(error);
          },
        });
    }
  }

  refreshFromServer() {
    if (this.clientId) {
      this.api
        ._admin_Client_retrieveById(this.clientId)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (clientData: ClientDTO) => {
            this.client = clientData;
            this.updateForm();
          },
          error: error => {
            this.errorhandler.errorHandler(error);
          },
        });
    } else {
      this.client = this.api.createDTO('ClientDTO');
      const address = this.api.createDTO('AddressDTO');
      address.country = 'DE';
      (this.client as unknown as any).primaryCompany = this.api.createDTO('CompanyDTO');
      this.client.primaryCompany.address = address;
      this.loading = false;
    }
  }

  updateForm() {
    if (this.client) {
      this.Name.setValue(this.client?.name);
      this.Identifier.setValue(this.client.primaryCompany.identifier);
      this.EMail.setValue(this.client.primaryCompany.email);
    }
  }
}
